// How a row of values folds into «+N» (owner 29.10, п.9): pure arithmetic of FitRow, kept apart so it is tested without a browser.

/**
 * How many of the drawn values fit into `room` whole, leaving room for the «+N» badge while some stay folded. At least one.
 * `beyond` counts values that are not drawn at all (a cell with hundreds of links draws the first ones): with any of them
 * the badge is always there, so its room is kept even when every drawn value fits.
 */
export function fitCount(widths: number[], room: number, gap: number, badge: number, beyond = 0): number {
  let used = 0;
  for (let i = 0; i < widths.length; i++) {
    const w = widths[i]! + (i ? gap : 0);
    const more = i < widths.length - 1 || beyond > 0 ? gap + badge : 0;
    if (used + w + more > room) return Math.max(1, i);
    used += w;
  }
  return widths.length;
}

/** The number on the badge: every value not shown in the row — the folded drawn ones and those never drawn. */
export const hiddenCount = (drawn: number, fit: number, total: number): number => Math.max(0, total - Math.min(fit, drawn));

/** The badge's hint names the hidden values; past `max` names it says how many more, so a hint never runs
 * for hundreds. Empty when none of the hidden values is drawn. */
export function hiddenHint(labels: string[], hidden: number, max = 20): string {
  const named = labels.slice(0, max);
  const rest = hidden - named.length;
  if (!named.length) return '';
  return rest > 0 ? `${named.join(', ')} и ещё ${rest}` : named.join(', ');
}
